(function () {
  if (!window.matchMedia('(max-width: 768px)').matches) return;

  var grid = document.getElementById('CollectionAjaxContent');
  if (!grid) return;

  var startX = 0;

  function initCard(mask) {
    if (mask.dataset.swipeReady) return;
    mask.dataset.swipeReady = '1';

    var urls = (mask.dataset.images || '').split('|||').filter(Boolean);
    if (urls.length < 2) return;

    var imgs = urls.map(function (url, i) {
      var img = document.createElement('img');
      img.src = url;
      img.loading = 'lazy';
      img.className = 'swipe-img' + (i === 0 ? ' is-active' : '');
      img.alt = '';
      mask.appendChild(img);
      return img;
    });

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'grid-product__swipe-dots';
    var dots = urls.map(function (_, i) {
      var dot = document.createElement('span');
      if (i === 0) dot.classList.add('is-active');
      dotsWrap.appendChild(dot);
      return dot;
    });
    mask.appendChild(dotsWrap);

    mask._swipe = { imgs: imgs, dots: dots, current: 0 };
  }

  function goTo(mask, direction) {
    var s = mask._swipe;
    if (!s) return;
    var next = (s.current + direction + s.imgs.length) % s.imgs.length;
    s.imgs[s.current].classList.remove('is-active');
    s.dots[s.current].classList.remove('is-active');
    s.imgs[next].classList.add('is-active');
    s.dots[next].classList.add('is-active');
    s.current = next;
  }

  grid.addEventListener('touchstart', function (e) {
    var mask = e.target.closest('.grid-product__image-mask');
    if (!mask) return;
    startX = e.touches[0].clientX;
    initCard(mask);
  }, { passive: true });

  grid.addEventListener('touchend', function (e) {
    var mask = e.target.closest('.grid-product__image-mask');
    if (!mask || !mask._swipe) return;
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) < 30) return;
    goTo(mask, diff > 0 ? 1 : -1);
  }, { passive: true });
})();